export const POST_MESSAGE_TYPE = {
    ACTIVE_CONTENT_BLOCK_CLICKED: 'ACTIVE_CONTENT_BLOCK_CLICKED',
    EDIT_CONTENT_BLOCK_CLICKED: 'EDIT_CONTENT_BLOCK_CLICKED',
    UPDATE_HIGHLIGHTED_ITEM: 'UPDATE_HIGHLIGHTED_ITEM',
    RELOAD_PAGE_DATA: 'RELOAD_PAGE_DATA'
};
